import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GlobalCssOverrideTheme from './GlobalCssOverrideTheme';
import ClientProvider from './client';
export default createDemo(import.meta.url, GlobalCssOverrideTheme, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/how-to-customize/demos/global-css-override-theme/GlobalCssOverrideTheme.tsx",
    "fileName": "GlobalCssOverrideTheme.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport GlobalStyles from '@mui/material/GlobalStyles';\n\nexport default function GlobalCssOverrideTheme() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <React.Fragment>\n      <GlobalStyles\n        styles={(theme) => ({\n          h1: { color: theme.palette.primary.main },\n        })}\n      />\n      <h1>Grey h1 element</h1>\n    </React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 15,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport GlobalStyles from '@mui/material/GlobalStyles';\n\nexport default function GlobalCssOverrideTheme() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <React.Fragment>\n      <GlobalStyles\n        styles={(theme) => ({\n          h1: { color: theme.palette.primary.main },\n        })}\n      />\n      <h1>Grey h1 element</h1>\n    </React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "GlobalStyles"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "styles"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "(",
              [
                "span",
                "pl-v di-jv",
                "theme"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ({"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "h1"
              ],
              ": { ",
              [
                "span",
                "di-op di-jv",
                "color"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "palette"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "primary"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "main"
              ],
              " },"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "        })",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      <",
              [
                "span",
                "pl-ent",
                "h1"
              ],
              ">Grey h1 element</",
              [
                "span",
                "pl-ent",
                "h1"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 15,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/GlobalStyles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
